<template>
  <div class="col-12">
    <PieChart :height="500" :chartData="testData" :options="options" />
  </div>
</template>

<script>
import { defineComponent, computed, ref } from "vue";
import { PieChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(...registerables);
Chart.register(ChartDataLabels);

export default defineComponent({
  components: { PieChart },
  props: ["titulo", "labels", "datasets"],
  setup(props) {
    const testData = computed(() => ({
      labels: props.labels,
      datasets: props.datasets,
    }));
    const options = ref({
      responsive: true,
      plugins: {
        datalabels: {
          listeners: {
            click: function (context, event) {
              console.log(context, event);
            },
          },
          color: "white",
          formatter: function (value, context) {
            return `${value}% ${context.dataset.label}`;
          },
        },
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: props.titulo,
          fontSize: 30,
        },
        pieceLabel: {
          render: "value",
          precision: 1,
        },
        showAllTooltips: true,
      },
    });

    return { testData, options };
  },
});
</script>
